import styled from 'styled-components'

export const Text = styled.span`
  display: block;
  margin-bottom: 30px;
  color: #202020;
  letter-spacing: 0.15px;
`

export const Control = styled.div`
  margin-bottom: 30px;
  margin-right: 20px;
  display: flex;
  align-items: flex-start;
`

export const ControlContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const Label = styled.label`
  margin-left: 12px;
  color: #202020;
  letter-spacing: 0.15px;
  line-height: 24px;

  span {
    display: block;
    color: rgba(0, 0, 0, 0.6);
  }
`
